import {
  PluginContainerData_Alignment,
  PluginContainerData_Width_Type,
  PollData_Design_PollDesign_Background_Type,
  PollData_Layout_PollLayout_Direction,
  PollData_Layout_PollLayout_Type,
  PollData_Poll_Settings_Permissions_ViewRole,
  PollData_Poll_Settings_Permissions_VoteRole
} from "./../ricos-schema/legacy/wix/rich_content/v1";
import { getRandomValue } from "./helpers";
const BACKGROUND_PRESETS = {
  [PollData_Design_PollDesign_Background_Type.COLOR]: [
    "#EF4538",
    "#F96132",
    "#FAAD4D",
    "#31B778",
    "#488FFE",
    "#11428D",
    "#6C49EF",
    "#8C0F7A"
  ],
  [PollData_Design_PollDesign_Background_Type.IMAGE]: [
    "https://static.wixstatic.com/media/2dfdd3_03c2331b19bb41108b34938edf8951dd~mv2.jpg",
    "https://static.wixstatic.com/media/2dfdd3_df028f9258cf4fe0a1b7f75a3916def1~mv2.jpg",
    "https://static.wixstatic.com/media/2dfdd3_b120b7d9cffd4645bb143beadef13c56~mv2.jpg",
    "https://static.wixstatic.com/media/2dfdd3_1977932e94064f168abaaa2c04b678a5~mv2.jpg",
    "https://static.wixstatic.com/media/2dfdd3_17b428ae1fb14736a2ab30994620ee62~mv2.jpg",
    "https://static.wixstatic.com/media/2dfdd3_934a080451cd4b3eb6e7c9485a07972c~mv2.jpg",
    "https://static.wixstatic.com/media/2dfdd3_0b440a1138ba4c99bc954eb4d06ec0ad~mv2.jpg",
    "https://static.wixstatic.com/media/2dfdd3_395a5522e3474b3ca34194633e90ea81~mv2.jpg"
  ],
  [PollData_Design_PollDesign_Background_Type.GRADIENT]: [
    {
      angle: 45,
      startColor: "#EF4538",
      lastColor: "#488FFE"
    },
    {
      angle: 45,
      startColor: "#F96132",
      lastColor: "#FAAD4D"
    },
    {
      angle: 45,
      startColor: "#31B778",
      lastColor: "#FAAD4D"
    },
    {
      angle: 45,
      startColor: "#0D6546",
      lastColor: "#31B778"
    },
    {
      angle: 45,
      startColor: "#488FFE",
      lastColor: "#8C0F7A"
    },
    {
      angle: 45,
      startColor: "#11428D",
      lastColor: "#488FFE"
    },
    {
      angle: 45,
      startColor: "#6C49EF",
      lastColor: "#31B778"
    },
    {
      angle: 45,
      startColor: "#8C0F7A",
      lastColor: "#FAAD4D"
    }
  ].map((value) => JSON.stringify(value))
};
const OPTION_IMAGES_POOL = [
  "https://static.wixstatic.com/media/fb62d9f8e7824b2e90b13b971e700b92.jpg",
  "https://static.wixstatic.com/media/3a27828e768344158489df4f2c03cfb2.jpg"
];
const POLL_IMAGES_POOL = [
  "https://static.wixstatic.com/media/436483e6ed9e41fe91b9f286d2ea4efb.jpg"
];
const DEFAULT_RICOS_COMPONENT_DATA = {
  containerData: {
    width: {
      size: PluginContainerData_Width_Type.CONTENT
    },
    alignment: PluginContainerData_Alignment.CENTER,
    textWrap: true
  },
  poll: {
    title: "",
    settings: {
      permissions: {
        view: PollData_Poll_Settings_Permissions_ViewRole.VOTERS,
        vote: PollData_Poll_Settings_Permissions_VoteRole.ALL,
        allowMultipleVotes: false
      },
      showVoters: true,
      showVotesCount: true
    },
    options: []
  },
  layout: {
    poll: {
      type: PollData_Layout_PollLayout_Type.LIST,
      direction: PollData_Layout_PollLayout_Direction.LTR,
      enableImage: true
    },
    options: {
      enableImage: false
    }
  },
  design: {
    poll: {
      background: {
        type: PollData_Design_PollDesign_Background_Type.IMAGE,
        image: {
          src: {
            url: getRandomValue(
              BACKGROUND_PRESETS[PollData_Design_PollDesign_Background_Type.IMAGE]
            )
          }
        }
      },
      borderRadius: 0
    },
    options: {
      borderRadius: 0
    }
  }
};
export {
  BACKGROUND_PRESETS,
  DEFAULT_RICOS_COMPONENT_DATA,
  OPTION_IMAGES_POOL,
  POLL_IMAGES_POOL
};
//# sourceMappingURL=defaults.js.map
